import React, {useContext} from "react";
import {StateContext} from "../context/GlobalState.jsx";
import {Link} from "react-router-dom";
import {GetText} from "../data/lang";


export const VendorsForCountry = (props) => {

    const {vendorList, lang} = useContext(StateContext);

    let vendorsShow = [];

    //Вывод логотипов
    let refreshVendors = (vendorsView) => {

        if (vendorsView.length > 0) {
            // console.log(props.countryId)
            vendorsView = vendorsView.filter(vend => vend.avaliable_counteies.split(',').includes(props.countryId));

            vendorsShow = vendorsView.map((vend) => <div key={`vendorsView-${vend.id}`}
                                                         className='col-md-2 col-sm-3 col-xs-6 team'>
                <div className='thumbnail'>{' '}
                    <Link title={vend.name} to={`/${lang}/vendor/${vend.link}`}> <img title={vend.name} src={`/img/vendors/${vend.img}`} alt={`logo-vendor-${vend.name}`}
                                             className='team-img'/></Link>
                </div>
            </div>)
        }

    }

    refreshVendors(vendorList);

    let text = GetText();

    return (
        <div>
            <div id='team' className='text-center'>
                <div className='container'>
                    <div className='col-md-12 section-title'>
                        <h2>{text ? text.VendorsForCountry.title : ""}</h2>
                        <p>

                        </p>
                    </div>
                    <div id='row'>
                        {vendorsShow.length > 0 ? vendorsShow : vendorList ? vendorList.map((vend) => <div
                            key={`${vend.id}`} className='col-md-2 col-sm-3 col-xs-6 team'>
                            <div className='thumbnail'>
                                {' '}
                                <Link to={`/${lang}/vendor/${vend.link}`}> <img src={`/img/vendors/${vend.img}`}
                                                         alt={`logo-vendor-${vend.name}`} className='team-img'/></Link>
                                {/*<div className='caption'>
                                <h4>{vend.name}</h4>

                            </div>*/}
                            </div>
                        </div>) : "Loading..."}
                    </div>
                </div>
            </div>
        </div>
    )
}
